/**
 * Below this the pane is not usable; it then overflows the fold instead of collapsing. In rem, like
 * what the pane holds, so it shrinks with the rest when index.css scales the UI to 80% (320px at
 * full size).
 */
export const MIN_PANE_REM = 20;

/**
 * The height the Media Library pane may take and still be fully visible the moment it opens: the
 * scrollport, minus how far below its top edge the pane's row starts when nothing is scrolled, minus
 * the bar pinned over the scrollport's bottom edge (the composer's "Save and close" bar; 0 when
 * there is none). `rem` is the px in one rem on screen (remPx), for the floor.
 *
 * Deliberately not the whole scrollport. A pane that tall has its footer - the only buttons it has -
 * below the fold on open, and is the tallest thing in its row, which leaves `sticky` no room to
 * travel, so it never pins on a large display. And inside the scrollport is not yet in sight: the
 * pinned bar is drawn over the last of it. A pane that reaches the bottom edge has its footer under
 * that bar, where a click meant for "Close Media Library" lands on "Save and close".
 */
export function paneHeightPx(
  scrollportHeight: number,
  rowRestTop: number,
  barHeight = 0,
  rem = 16,
): number {
  return Math.max(
    Math.floor(MIN_PANE_REM * rem),
    Math.floor(scrollportHeight - rowRestTop - barHeight - 1),
  );
}
